import {axiosInstance} from "../axios";
import { brand_apis } from '../ApiConst';
export const Get_Brand_Categories = async () => {
  return await axiosInstance.get(brand_apis.get_brand_categories, {
    useUserToken: true,
  });
};

export const Get_Brands = async () => {
  return await axiosInstance.get(brand_apis.get_brands, {
    useUserToken: true,
  });
}

export const Request_New_Brand = async (data) => {
  return await axiosInstance.post(brand_apis.request_new_brand, data, {
    useUserToken: true,
  });
}